"use strict";

import angular from "angular";

angular.module("nucont.accounting.group").config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider
        .state("nucont.accounting.group.demonstrations.accounting.dre", {
            url: "/DRE/:date/:view",
            views: {
                "demonstrationAccountingView@nucont.accounting.group.demonstrations.accounting": {
                    component: "accountingDreComponent",
                    bindings: { companyData: "groupData" }
                }
            },
            params: {
                demonstration: { value: "DRE", dynamic: false },
                date: { value: null, dynamic: true },
                view: { value: "mensal", dynamic: true },
                stateIndentifier: { value: "dre" }
            },
            bodyClass: "dre-module"
        })
        .state(
            "nucont.accounting.group.demonstrations.accounting.dre.showtime",
            {
                url: "/showtime",
                bodyClass: "dre-module"
            }
        )
        .state(
            "nucont.accounting.group.demonstrations.accounting.dre.showtime.description",
            {
                url: "/descricao",
                views: {
                    "subModule@nucont.accounting.group.demonstrations.accounting.dre": {
                        component: "indicatorDescriptionComponent"
                    }
                },
                bodyClass: "dre-module"
            }
        )
        .state(
            "nucont.accounting.group.demonstrations.accounting.dre.showtime.comments",
            {
                url: "/comentarios",
                views: {
                    "subModule@nucont.accounting.group.demonstrations.accounting.dre": {
                        component: "indicatorCommentsComponent"
                    }
                },
                bodyClass: "dre-module"
            }
        )
        .state(
            "nucont.accounting.group.demonstrations.accounting.dre.showtime.insights",
            {
                url: "/insights",
                views: {
                    "subModule@nucont.accounting.group.demonstrations.accounting.dre": {
                        component: "indicatorInsightsComponent"
                    }
                },
                bodyClass: "dre-module"
            }
        )
        .state(
            "nucont.accounting.group.demonstrations.accounting.dre.comparation",
            {
                url:
                    "/comparacao?month&comparationView&comparationDate&analysisHorizontal&analysisVertical",
                views: {
                    "demonstrationAccountingView@nucont.accounting.group.demonstrations.accounting": {
                        component: "accountingDreComparationComponent",
                        bindings: { companyData: "groupData" }
                    }
                },
                params: {
                    comparationView: { value: null, dynamic: true },
                    comparationDate: { value: null, dynamic: true },
                    analysisHorizontal: { value: null, dynamic: true },
                    analysisVertical: { value: null, dynamic: true },
                    month: { value: null, dynamic: true },
                    stateIndentifier: { value: "dre.comparation" }
                },
                bodyClass: "dre-module"
            }
        )
        .state(
            "nucont.accounting.group.demonstrations.accounting.dre.comparation.showtime",
            {
                url: "/showtime",
                bodyClass: "dre-module"
            }
        )
        .state(
            "nucont.accounting.group.demonstrations.accounting.dre.comparation.showtime.description",
            {
                url: "/descricao",
                views: {
                    "subModule@nucont.accounting.group.demonstrations.accounting.dre.comparation": {
                        component: "indicatorDescriptionComponent"
                    }
                },
                bodyClass: "dre-module"
            }
        )
        .state(
            "nucont.accounting.group.demonstrations.accounting.dre.comparation.showtime.comments",
            {
                url: "/comentarios",
                views: {
                    "subModule@nucont.accounting.group.demonstrations.accounting.dre.comparation": {
                        component: "indicatorCommentsComponent",
                        bindings: { companyData: "groupData" }
                    }
                },
                bodyClass: "dre-module"
            }
        )
        .state(
            "nucont.accounting.group.demonstrations.accounting.dre.comparation.showtime.insights",
            {
                url: "/insights",
                views: {
                    "subModule@nucont.accounting.group.demonstrations.accounting.dre.comparation": {
                        component: "indicatorInsightsComponent"
                    }
                },
                bodyClass: "dre-module"
            }
        );
}
